module.exports = __webpack_public_path__ + "img/Wp_2073.410794ed.png";